import {Component, forwardRef, AfterViewInit, ElementRef, ViewChild} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import SignaturePad from 'signature_pad';
import { ElectronicSignatureModel } from '../electronic-signature.model';
import { AbstractWorkflowFormComponent } from '../../@core/abstract-workflow-form-component';

@Component({
    selector: 'abw-electronic-signature-form',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => ElectronicSignatureFormComponent),
        multi: true
      }
    ],
    templateUrl: './electronic-signature-form.component.html',
    styleUrls: ['./electronic-signature-form.component.scss']
})
export class ElectronicSignatureFormComponent extends AbstractWorkflowFormComponent<ElectronicSignatureModel, string> implements AfterViewInit {
	signaturePad: SignaturePad = null;
	@ViewChild('canvasPad', { static: false }) canvasPad: ElementRef;
	@ViewChild('wraperPad', { static: false }) wraperPad: ElementRef;

    ngAfterViewInit(): void {
      super.ngAfterViewInit();
      this.signaturePad = new SignaturePad(this.canvasPad.nativeElement, {
        onEnd: () => {
          const value = this.signaturePad.toDataURL().replace('data:image/png;base64,', '');
          this.onValueChanged(value);
        }
      });
    }

    clearSignature() {
		this.signaturePad.clear();
		this.onValueChanged(null);
    }
}